import { createContext } from 'react';

export const SchedulesContext = createContext(null);
SchedulesContext.displayName = 'SchedulesContext';
